<span *ngIf="tarifficationPeriod == 1">
  {{ tarifficationPeriodPrice | number:'1.0-2' }} ₽ ∙ {{ duration }} мин.
</span>
<span *ngIf="tarifficationPeriod > 1">
  {{ tarifficationPeriodPrice | number:'1.0-2' }} ₽ ∙ {{ periodsCount }} по {{ tarifficationPeriod }} мин.
</span>
<span *ngIf="multiplier > 1"> ∙ {{ multiplier }}</span>
<span *ngIf="cost !== undefined">= {{ cost | number:'1.0-2' }} ₽</span>
